module.exports = __webpack_public_path__ + "img/002.0cf045cf.svg";